<template>
	<div>
		<div style="display: flex;">
			<div style="flex: 1;font-weight: 800;font-size: 18px;">管理员中心</div>
			<div style="width: 100%;text-align: right;margin-bottom: 10px;flex: 5;" v-if="this.adminId==8">
				<el-button type="primary" @click="add()">新建</el-button>
			</div>
		</div>
		<div>
			<el-table :data="data"
				:header-cell-style="{ background: '#d8d8d8', 'text-align': 'center', color: '#2D2D2D' }"
				:cell-style="{'text-align':'center','width':'auto'}">
				<el-table-column prop="id" label="ID" />
				<el-table-column label="账号">
					<template slot-scope="{row}">
						<div v-if="row.edit==false">{{row.account}}</div>
						<el-input v-else v-model="row.account" class="w100"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="密码">
					<template slot-scope="{row}">
						<div v-if="row.edit==false">******</div>
						<el-input v-else v-model="row.password" class="w100"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="名称">
					<template slot-scope="{row}">
						<div v-if="row.edit==false">{{row.username}}</div>
						<el-input v-else v-model="row.username" class="w100"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="简介">
					<template slot-scope="{row}">
						<div v-if="row.edit==false">{{row.introduction}}</div>
						<el-input v-else v-model="row.introduction" class="w100"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="更新时间">
					<template slot-scope="{row}">
						<div>{{row.updateTime}}</div>
					</template>
				</el-table-column>
				<el-table-column label="状态0正常 1冻结">
					<template slot-scope="{row}">
						<div v-if="row.edit==false">{{row.status|statusFormat}}</div>
						<el-input v-else v-model="row.status" class="w100"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="{row}">
						<div>
							<el-button size="small" type="danger" @click="remove(row.id)"
								v-if="adminId==8">注销</el-button>
							<el-button v-if="row.edit==false" size="small" type="primary"
								@click="edit(row)">编辑</el-button>
							<div v-else style="display: flex;float: right;">
								<el-button size="small" type="primary" @click="save(row)">保存</el-button>
								<el-button size="small" type="primary" @click="goback(row)">取消</el-button>
							</div>
						</div>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagechange">
			<el-pagination @size-change="handleSizeChange" @current-change="handlePageChange"
				:current-page="filter.page" :page-sizes="[10,20,50]" :page-size="filter.size"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	const that = this
	export default {
		data() {
			return {
				adminId: null,
				total: 0,
				data: {
					id: '',
					account: '',
					password: '',
					status: '',
					username: '',
					account: '',
					introduction: '',
					updateTime: '',
				},
				filter: {
					page: 1,
					size: 10
				}
			}
		},
		filters: {
			m(val) {
				switch (val.timeType) {
					case 0:
						return '周日'
					case 1:
						return '周一'
					case 2:
						return '周二'
					case 3:
						return '周三'
					case 4:
						return '周四'
					case 5:
						return '周五'
					case 6:
						return '周六'
				}
			},
			statusFormat(val) {
				switch (val) {
					case 0:
						return "正常";
					case 1:
						return "冻结";
					default:
						return '/';
				}
			},
		},
		mounted() {
			this.adminId = localStorage.getItem('adminId')
			this.getList()
		},
		methods: {
			getList() {
				this.$http.get("manager/adminList?page=" + this.filter.page + "&size=" + this.filter.size + "&adminId=" +
					localStorage.getItem("adminId")).then(res => {
					console.log(res)
					if (res.body.code == 200) {
						this.data = res.body.data.records
						// this.filter.page = res.body.page
						// this.filter.size = res.body.size
						this.total = res.body.data.total
						this.data.forEach(d => {
							this.$set(d, "edit", false)
							d.password = ''
						})
					}
				})
			},
			goback(row) {
				row.edit = false
				this.getList()
			},
			save(row) {
				var a = {
					adminId: localStorage.getItem("adminId"),
					account: row.account,
					password: row.password,
					status: row.status,
					userName: row.username,
					account: row.account,
					introduction: row.introduction
				}
				if (row.id) {
					a.userId = row.id
					this.$http.post("manager/update", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.getList()
							this.$message.success("保存成功")
						} else {
							this.$message.error("保存失败")
						}
					})
				} else {
					this.$http.post("manager/saveUser", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.getList()
							this.$message.success("新建成功")
						} else {
							this.$message.error("新建失败")
						}
					})
				}
				// row.edit = false	
				// this.getList()
			},
			edit(row) {
				row.edit = true
			},
			add() {
				var a = {
					userId: '',
					account: '',
					password: '',
					username: '',
					introduction: '',
					status: 0,
				}
				this.data.unshift(a)
			},
			remove(userId) {
				var a = {
					adminId: localStorage.getItem("adminId"),
					userId: userId
				}
				this.$http.post("manager/del", JSON.stringify(a)).then(res => {
					if (res.body.code == 200) {
						console.log("1212")
						this.getList()
						this.$message.success("注销成功")
					} else {
						this.$message.error("注销失败")
					}
				})

			},
			// 分页-每页大小发生改变时触发
			handleSizeChange(val) {
				this.filter.size = val;
				this.getList();
			},
			// 分页-页数发生改变时触发
			handlePageChange(val) {
				this.filter.page = val;
				this.getList();
			},
		}
	}
</script>

<style>
	.pagescg {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.pagechange {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>